import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0016',
    ecrans: ['00-2'],
    params: [
        '?reference'
    ]
});
